module.exports = __webpack_public_path__ + "assets/613a81ae1adf23d4bedeca272ef19765.svg";